import { Component, OnInit } from "@angular/core";
import { EventContentDto, EventDto, UserDto } from "@api";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { AppRoutes } from "src/app/constants";
import { RootState } from "src/app/store";
import * as EventActions from "src/app/store/event/actions";
import * as FromUser from "src/app/store/user/selectors";
import * as FromEvent from "src/app/store/event/selectors";
import * as FromRouter from "src/app/store/router/selectors";
import { Browser } from "@capacitor/browser";
import { first } from "rxjs/operators";
import { AlertController, IonRouterOutlet, ModalController } from "@ionic/angular";
import { IframeModal } from "src/app/modals/iframe-modal/iframe-modal.page";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-event-detail",
  templateUrl: "./event-detail.page.html",
  styleUrls: ["./event-detail.page.scss"],
})
export class EventDetailPage implements OnInit {
  public routes: typeof AppRoutes = AppRoutes;
  public presentingElement: HTMLElement;
  public checkUpType: EventContentDto.TypeEnum = EventContentDto.TypeEnum.CheckUp;
  public event$: Observable<EventDto> = this.store.select(FromEvent.selectEvent);
  public user$: Observable<UserDto> = this.store.select(FromUser.selectUser);
  public breadcrumbs = [{ name: "Dashboard", link: `/${this.routes.home}` }, { name: "Veranstaltungen" }];

  constructor(
    private store: Store<RootState>,
    private routerOutlet: IonRouterOutlet,
    private modalController: ModalController,
    private alertController: AlertController,
    private i18n: TranslateService,
  ) {}

  public ngOnInit(): void {
    this.presentingElement = this.routerOutlet.nativeEl;
  }

  public async rescheduleCheckUp(event: EventDto): Promise<void> {
    const url = event.externalLink;

    if (!url) {
      const alert = await this.alertController.create({
        header: this.i18n.instant("EVENT_RESPONSE.RESCHEDULE_ALERT_HEADER"),
        message: this.i18n.instant("EVENT_RESPONSE.RESCHEDULE_ALERT_MESSAGE"),
        buttons: [{ role: "cancel", text: this.i18n.instant("EVENT_RESPONSE.RESCHEDULE_ALERT_BUTTON") }],
      });

      return alert.present();
    }

    const modal = await this.modalController.create({
      component: IframeModal,
      componentProps: { url: event.externalLink },
      presentingElement: this.presentingElement,
      cssClass: ["event-reschedule-modal"],
      swipeToClose: true,
    });

    await modal.present();
  }

  public joinEvent(): void {
    this.event$.pipe(first()).subscribe(event => Browser.open({ url: event.location }));
  }

  protected ionViewDidEnter(): void {
    this.store
      .select(FromRouter.selectEventId)
      .pipe(first())
      .subscribe(eventId => {
        this.store.dispatch(EventActions.getReferents());
        this.store.dispatch(EventActions.getEvent({ eventId, fetchNested: true }));
      });
  }
}
